// modal/leger.js
import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
// import { APILA } from "../../../../../config/apila";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { Button } from "reactstrap";
import axios from "axios";
import { ClipLoader} from "react-spinners";
import ToastError from "../../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../../NotificationToast/ToastSuccess";

export default function ModalLeger({ show, onHide, data_leger }) {
  const [rows, setRows] = useState([]);
  const [savingMap, setSavingMap] = useState({});

  // selalu pegang state rows terbaru agar save tidak baca state lama
  const rowsRef = useRef([]);
  useEffect(() => {
    rowsRef.current = rows;
  }, [rows]);

  const token = localStorage.getItem("token");
  const user_id = localStorage.getItem("id_admin")?.replace(/[|&;$%@"<>()+,]/g, "");

  const roleName = localStorage.getItem("ysb_role_name") || "";
  // ✅ Sesuai requirement: Pengawas Adab hanya boleh input di kolom Karyawan (Adab)
  const canEditKaryawan = roleName === "Pengawas Adab";

  const savingKey = (rowIndex, group) => `${group}__${rowIndex}`;

  const getValue = (row, key) => {
    if (!row || !row[key]) return {};
    return row[key]; // object
  };

  // konversi "25" atau "25%" menjadi 0.25
  const parsePercentage = (val) => {
    if (val === null || val === undefined || val === "") return 0;
    const cleaned = val.toString().replace("%", "").trim();
    const num = parseFloat(cleaned);
    if (isNaN(num)) return 0;
    return num / 100;
  };

  // hitung capaian x bobot → 2 angka di belakang koma
  const calculateScore = (capaian, bobot) => {
    const c = parseFloat(capaian ?? 0);
    const b = parsePercentage(bobot);
    if (!c || !b) return 0;
    return parseFloat((c * b).toFixed(2));
  };

  // ambil nilai yang akan ditampilkan:
  // 1. kalau field .nilai sudah terisi dan numerik → pakai itu
  // 2. kalau kosong → hitung dari capaian x bobot
  const getScore = (item) => {
    if (!item) return 0;

    if (item.nilai !== undefined && item.nilai !== null && item.nilai !== "") {
      const n = parseFloat(item.nilai);
      if (!isNaN(n)) return n;
    }

    return calculateScore(item.capaian, item.bobot);
  };

  const formatScore = (num) => {
    if (num === null || num === undefined || num === "") return "";
    const n = Number(num);
    if (!Number.isFinite(n)) return "";
    if (Number.isInteger(n)) return n.toString();
    return n.toFixed(2);
  };

  // hitung nilai akhir per baris (jumlah semua nilai)
  const calculateFinal = (row) => {
    const kepsek = getValue(row, "nilai_kepala_sekolah");
    const guru = getValue(row, "nilai_guru");
    const muridPeer = getValue(row, "nilai_murid_peer_assessment");
    const muridSelf = getValue(row, "nilai_murid_self_assessment");
    const otm = getValue(row, "nilai_orang_tua_murid");
    const karyawan = getValue(row, "nilai_karyawan");

    const total =
      getScore(kepsek) +
      getScore(guru) +
      getScore(muridPeer) +
      getScore(muridSelf) +
      getScore(karyawan) +
      getScore(otm);

    return formatScore(total);
  };

  // tentukan KKCA berdasarkan nilai akhir
  const getKKCA = (finalScore) => {
    const n = parseFloat(finalScore);

    if (isNaN(n)) return ""; // kalau belum ada nilai

    if (n >= 1 && n <= 2.49) return "Adab Mulai Terpuji";
    if (n >= 2.5 && n <= 2.99) return "Adab Cukup Terpuji";
    if (n >= 3.0 && n <= 3.49) return "Adab Terpuji";
    if (n >= 3.5 && n <= 4.0) return "Adab Sangat Terpuji";

    return "";
  };

  // setiap kali data_leger berubah, isi ulang baris
  useEffect(() => {
    const nextRows = (data_leger?.sub_elements || []).map((r) => {
      const nk = r?.nilai_karyawan ? { ...r.nilai_karyawan } : {};
      // untuk prevent save berulang (blur tanpa perubahan)
      nk.__lastSavedCapaian = nk.capaian ?? "";

      const baseRow = { ...r, nilai_karyawan: nk };
      return {
        ...baseRow,
        // nilai akhir langsung siap tampil (dan akan auto berubah saat input)
        nilai_akhir: baseRow.nilai_akhir ?? calculateFinal(baseRow),
      };
    });

    setRows(nextRows);
  }, [data_leger]); // eslint-disable-line react-hooks/exhaustive-deps

  // input yang bisa di-edit (karyawan) → auto hitung nilai-nya & nilai akhir realtime
  const handleChangeInput = (index, group, field, value) => {
    setRows((prev) => {
      const copy = [...(prev || [])];
      const target = { ...(copy[index] || {}) };

      const groupObj = { ...(target[group] || {}) };
      groupObj[field] = value;

      // auto hitung nilai (capaian x bobot)
      const { capaian, bobot } = groupObj;
      groupObj.nilai = calculateScore(capaian, bobot);

      target[group] = groupObj;

      // ✅ nilai akhir otomatis berubah saat user input nilai
      target.nilai_akhir = calculateFinal(target);

      copy[index] = target;
      return copy;
    });
  };

  const saveNilai = async (rowIndex, group) => {
    const row = rowsRef.current?.[rowIndex];
    if (!row) return;

    const nilaiObj = row[group];
    if (!nilaiObj) return;

    // id = "default" => create, selain itu => update
    const recapId = nilaiObj?.id && nilaiObj.id !== "default" ? nilaiObj.id : "default";

    // ✅ hanya simpan kalau ada perubahan (biar tidak spam request/toast)
    const currentCapaianStr = (nilaiObj?.capaian ?? "").toString();
    const lastSavedStr = (nilaiObj?.__lastSavedCapaian ?? "").toString();
    if (currentCapaianStr === lastSavedStr) return;

    // Ambil teacher_id dari data_leger (lebih aman)
    const teacherId = data_leger?.ysb_teacher_id || localStorage.getItem("ysb_teacher_id") || "";

    // normalize capaian
    const raw = nilaiObj?.capaian;
    const capaianNum = raw === "" || raw === null || raw === undefined ? null : Number(raw);
    const ysb_sub_element_value = Number.isFinite(capaianNum) ? capaianNum : null;

    const payload = {
      ysb_dimensi_id: data_leger?.ysb_dimensi_id,
      ysb_element_id: data_leger?.ysb_element_id,
      ysb_semester_id: data_leger?.ysb_semester_id,
      ysb_school_id: data_leger?.ysb_school_id,
      ysb_branch_id: data_leger?.ysb_branch_id,
      ysb_teacher_id: teacherId,
      ysb_student_id: data_leger?.ysb_student_id,
      ysb_kelas_id: data_leger?.ysb_kelas_id,
      ysb_categories_penilai_id: nilaiObj?.ysb_categories_penilai_id,
      ysb_sub_element_id: row?.ysb_sub_element_id,
      ysb_sub_element_value,
      user_id,
    };

    const requiredKeys = [
      "ysb_dimensi_id",
      "ysb_element_id",
      "ysb_semester_id",
      "ysb_school_id",
      "ysb_branch_id",
      "ysb_teacher_id",
      "ysb_kelas_id",
      "ysb_student_id",
      "ysb_categories_penilai_id",
      "ysb_sub_element_id",
      "user_id",
    ];
    const missing = requiredKeys.filter((k) => !payload[k]);
    if (missing.length) {
      ToastError.fire({
        icon: "error",
        title: "Tidak bisa menyimpan: data wajib masih kosong",
      });
      console.error("Tidak bisa simpan. Field wajib kosong:", missing, payload);
      return;
    }

    const key = savingKey(rowIndex, group);
    setSavingMap((prev) => ({ ...prev, [key]: true }));

    try {
      const res = await axios.put(
        `https://api.la.sims.alazharsummarecon.sch.id/api/leger-recaps/${recapId}`,
        payload,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );

      // ✅ Toast sukses sesuai contoh kamu
      ToastSuccess.fire({
        icon: "success",
        title: res?.data?.message || "Nilai berhasil disimpan",
      });

      // update lastSaved
      setRows((prev) => {
        const copy = [...(prev || [])];
        const target = { ...(copy[rowIndex] || {}) };
        const groupObj = { ...(target[group] || {}) };
        groupObj.__lastSavedCapaian = currentCapaianStr;
        target[group] = groupObj;
        copy[rowIndex] = target;
        return copy;
      });

      // kalau sebelumnya default, coba update id yang baru dibuat supaya next save jadi update
      if (recapId === "default") {
        const newId =
          res?.data?.data?.id ||
          res?.data?.id ||
          res?.data?.data?.ysb_element_recap_id;

        if (newId) {
          setRows((prev) => {
            const copy = [...(prev || [])];
            const target = { ...(copy[rowIndex] || {}) };
            const groupObj = { ...(target[group] || {}) };
            groupObj.id = newId;
            target[group] = groupObj;
            copy[rowIndex] = target;
            return copy;
          });
        }
      }
    } catch (err) {
      console.error("Gagal simpan nilai:", err);

      ToastError.fire({
        icon: "error",
        title: err?.response?.data?.message || err?.message || "Tidak berhasil menyimpan",
      });
    } finally {
      setSavingMap((prev) => {
        const next = { ...prev };
        delete next[key];
        return next;
      });
    }
  };

  return (
    <Modal show={show} onHide={onHide} fullscreen centered backdrop="static">
      {/* HEADER MODAL */}
      <div className="d-flex align-items-center px-3 pt-3 mb-4">
        <div>
          <h5>{data_leger?.name_student}</h5>
          <p>
            <b>Element:</b> {data_leger?.name_element || "-"}{" "}
            {data_leger?.description ? `- ${data_leger.description}` : ""}
          </p>
        </div>

        <div className="ml-auto x-close">
          <FontAwesomeIcon
            style={{ fontSize: "27px", marginRight: "20px", cursor: "pointer" }}
            icon={faXmark}
            onClick={onHide}
          />
        </div>
      </div>
      <hr className="mt-2 mb-0" />

      {/* BODY MODAL */}
      <Modal.Body style={{ paddingTop: 10 }}>
        {/* WRAPPER UNTUK SCROLL KE SAMPING */}
        <div
          style={{
            width: "100%",
            overflowX: "auto",
            WebkitOverflowScrolling: "touch",
            border: "1px solid #dee2e6",
          }}
        >
          <table
            className="table table-bordered table-laporan-adab mb-0"
            style={{ minWidth: "1500px", whiteSpace: "nowrap" }}
          >
            <thead style={{ backgroundColor: "#0d6efd", color: "white" }}>
              <tr>
                <th
                  rowSpan={2}
                  style={{
                    verticalAlign: "middle",
                    textAlign: "center",
                    border: "1px solid #fff",
                    color: "#fff",
                  }}
                >
                  Indikator
                </th>
                <th colSpan={3} style={{ textAlign: "center", border: "1px solid #fff", color: "#fff" }}>
                  Kepala Sekolah
                </th>
                <th colSpan={3} style={{ textAlign: "center", border: "1px solid #fff", color: "#fff" }}>
                  Guru
                </th>
                <th colSpan={3} style={{ textAlign: "center", border: "1px solid #fff", color: "#fff" }}>
                  Murid <i>(Peer Assessment)</i>
                </th>
                <th colSpan={3} style={{ textAlign: "center", border: "1px solid #fff", color: "#fff" }}>
                  Murid <i>(Self Assessment)</i>
                </th>
                <th colSpan={3} style={{ textAlign: "center", border: "1px solid #fff", color: "#fff" }}>
                  Orang Tua
                </th>
                <th colSpan={3} style={{ textAlign: "center", border: "1px solid #fff", color: "#fff" }}>
                  Karyawan
                </th>
                <th
                  rowSpan={2}
                  style={{
                    verticalAlign: "middle",
                    textAlign: "center",
                    border: "1px solid #fff",
                    color: "#fff",
                  }}
                >
                  Nilai Akhir
                </th>
                <th
                  rowSpan={2}
                  style={{
                    verticalAlign: "middle",
                    textAlign: "center",
                    border: "1px solid #fff",
                    color: "#fff",
                  }}
                >
                  KKCA
                </th>
              </tr>

              <tr>
                {["Capaian", "Bobot", "Nilai"].map((h, i) => (
                  <th key={`kepsek-${i}`} style={{ textAlign: "center", border: "1px solid #fff", color: "#fff" }}>
                    {h}
                  </th>
                ))}
                {["Capaian", "Bobot", "Nilai"].map((h, i) => (
                  <th key={`guru-${i}`} style={{ textAlign: "center", border: "1px solid #fff", color: "#fff" }}>
                    {h}
                  </th>
                ))}
                {["Capaian", "Bobot", "Nilai"].map((h, i) => (
                  <th key={`murid-${i}`} style={{ textAlign: "center", border: "1px solid #fff", color: "#fff" }}>
                    {h}
                  </th>
                ))}
                {["Capaian", "Bobot", "Nilai"].map((h, i) => (
                  <th key={`murid2-${i}`} style={{ textAlign: "center", border: "1px solid #fff", color: "#fff" }}>
                    {h}
                  </th>
                ))}
                {["Capaian", "Bobot", "Nilai"].map((h, i) => (
                  <th key={`otm-${i}`} style={{ textAlign: "center", border: "1px solid #fff", color: "#fff" }}>
                    {h}
                  </th>
                ))}
                {["Capaian", "Bobot", "Nilai"].map((h, i) => (
                  <th key={`karyawan-${i}`} style={{ textAlign: "center", border: "1px solid #fff", color: "#fff" }}>
                    {h}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {rows.map((row, idx) => {
                const kepsek = getValue(row, "nilai_kepala_sekolah");
                const guru = getValue(row, "nilai_guru");
                const muridPeer = getValue(row, "nilai_murid_peer_assessment");
                const muridSelf = getValue(row, "nilai_murid_self_assessment");
                const otm = getValue(row, "nilai_orang_tua_murid");
                const karyawan = getValue(row, "nilai_karyawan");

                const isSavingKaryawan = !!savingMap[savingKey(idx, "nilai_karyawan")];

                const finalScore = calculateFinal(row);

                return (
                  <tr key={row.ysb_sub_element_id || idx}>
                    <td
                      style={{
                        border: "1px solid #000",
                        verticalAlign: "top",
                        width: "380px",
                        maxWidth: "380px",
                        minWidth: "380px",
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        overflowWrap: "break-word",
                        lineHeight: "1.5",
                      }}
                    >
                      {row.ysb_sub_element_name}
                    </td>

                    {/* KEPSEK (READ ONLY) */}
                    <td style={{ border: "1px solid #000", textAlign: "center", lineHeight: "2" }}>{kepsek.capaian ?? ""}</td>
                    <td style={{ border: "1px solid #000", textAlign: "center", lineHeight: "2" }}>{kepsek.bobot ?? ""}</td>
                    <td style={{ border: "1px solid #000", textAlign: "center", lineHeight: "2" }}>{kepsek.nilai ?? ""}</td>

                    {/* GURU (READ ONLY) */}
                    <td style={{ border: "1px solid #000", textAlign: "center", lineHeight: "2" }}>{guru.capaian ?? ""}</td>
                    <td style={{ border: "1px solid #000", textAlign: "center", lineHeight: "2" }}>{guru.bobot ?? ""}</td>
                    <td style={{ border: "1px solid #000", textAlign: "center", lineHeight: "2" }}>{guru.nilai ?? ""}</td>

                    {/* MURID (READ ONLY) */}
                    <td style={{ border: "1px solid #000", textAlign: "center", lineHeight: "2" }}>{muridPeer.capaian ?? ""}</td>
                    <td style={{ border: "1px solid #000", textAlign: "center", lineHeight: "2" }}>{muridPeer.bobot ?? ""}</td>
                    <td style={{ border: "1px solid #000", textAlign: "center", lineHeight: "2" }}>{muridPeer.nilai ?? ""}</td>

                    {/* MURID (READ ONLY) */}
                    <td style={{ border: "1px solid #000", textAlign: "center", lineHeight: "2" }}>{muridSelf.capaian ?? ""}</td>
                    <td style={{ border: "1px solid #000", textAlign: "center", lineHeight: "2" }}>{muridSelf.bobot ?? ""}</td>
                    <td style={{ border: "1px solid #000", textAlign: "center", lineHeight: "2" }}>{muridSelf.nilai ?? ""}</td>

                    {/* ORANG TUA (READ ONLY) */}
                    <td style={{ border: "1px solid #000", textAlign: "center", lineHeight: "2" }}>{otm.capaian ?? ""}</td>
                    <td style={{ border: "1px solid #000", textAlign: "center", lineHeight: "2" }}>{otm.bobot ?? ""}</td>
                    <td style={{ border: "1px solid #000", textAlign: "center", lineHeight: "2" }}>{otm.nilai ?? ""}</td>

                    {/* KARYAWAN (READ ONLY) */}
                    <td style={{ border: "1px solid #000", textAlign: "center", lineHeight: "2" }}>{karyawan.capaian ?? ""}</td>
                    <td style={{ border: "1px solid #000", textAlign: "center", lineHeight: "2" }}>{karyawan.bobot ?? ""}</td>
                    <td style={{ border: "1px solid #000", textAlign: "center", lineHeight: "2" }}>{formatScore(getScore(karyawan))}</td>

                    {/* NILAI AKHIR (realtime) + loading saat simpan */}
                    <td style={{ border: "1px solid #000", textAlign: "center", lineHeight: "2" }}>
                      {isSavingKaryawan ? (
                        // <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                        <ClipLoader size={16} color="#3f5bea"  />
                      ) : (
                        finalScore
                      )}
                    </td>

                    {/* KKCA (realtime) */}
                    <td style={{ border: "1px solid #000", textAlign: "center", fontWeight: "bold", lineHeight: "2" }}>
                      {row.kkca_description}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <div className="d-flex justify-content-center w-100 ">
          <Button className="btn btn-tutup" style={{ backgroundColor: "#faa200ff", border: "none" }} onClick={onHide}>
            Tutup
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
